import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};
function SAMPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Materials and Methods</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p style={{ fontSize: "1.1em" }}>
              <ul>
                <li style={{ fontSize: "1.5em" }}>
                  {" "}
                  <b> Study Area</b>
                </li>
              </ul>
              <p style={{ fontSize: "1.1em" }}>
                Goa, with a spatial extent of 3702 sq. km comprising two
                districts, North Goa and South Goa (Figure 8) is the 25
                <sup>th</sup> State of the Union states of India on the west
                coast of India, located between 15&deg; 48&rsquo; 00"N 74&deg;
                20&rsquo; 13" E and 14&deg; 43&rsquo; 54" N 73&deg; 40&rsquo;
                33"E. Several major rivers traverse the region, including the
                Mandovi, Zuari, Terekhol, Chapora, Sal, Talpona, Galgibag, and
                Betul. The Mountain region of Goa is situated east of South Goa
                and is covered in dense forest. The climate of Goa is hot and
                experiences rainfall in June, July, August, and September.
                Mainly plantations of cashews, Coconut, Mangoes, Areca palm,
                Kokum, and Jack fruit are predominant in Goa. Goa possesses
                abundant mineral resources, including iron ore, manganese,
                ferromanganese, bauxite, and silica sand. The iron and manganese
                mining industries are crucial for the economy. Rivers serve as a
                means of transportation, and inland waterways are exceptionally
                vital for transporting mineral ores from mining sites such as
                Costi, Kirpal, Netravalim, Rivona, Ducorcond, and Kuddegal in
                the Sanguem taluka to the Mormugao harbor for export. As per
                India State of Forest Report (ISFR) 2023, the spatial extent of
                the forest cover of&nbsp;Goa is 2,265.72 sq. km [19], and
                diversity is due to the variation in altitude, aspect, soil
                characters, slope, etc. Forests provide essential products:
                bamboo, fuelwood, non-timber forest produce (NTFP), etc. As per
                the classification of forest types in India [120], the forests
                of Goa include (i) estuarine vegetation consisting of mangrove
                species, (ii) stranded vegetation along the coastal belts, (iii)
                plateau vegetation is confined especially to the low altitude
                (open scrub jungle, moist mixed deciduous forests, secondary
                moist mixed deciduous forests, subtropical hill forests), and
                (iv) Semi-evergreen and evergreen forests (Semi-evergreen
                forests, Lateritic Semi-evergreen forests, Evergreen forests).
                Conservation of the unique biodiversity of the State has been
                implemented through protected areas of six Wildlife Sanctuaries
                and one National Park.
              </p>
              <p style={{ fontSize: "1.1em", textAlign: "center" }}>
                <img
                  width={500}
                  height={300}
                  src="images/final_images/fig1.png"
                  alt=""
                />
                <br />
                <strong>Figure 8. </strong>Study area- Goa State, Central
                Western Ghats, India. Created using the open-source software
                QGIS 3.10 [https://www.qgis.org/] and GRASS GIS 7.8.2
                [https://wgbis.ces.iisc.ac.in/grass/].
              </p>
              <ul>
                <li style={{ fontSize: "1.3em" }}>
                  {" "}
                  <b>Data</b>{" "}
                </li>
              </ul>
              <p style={{ fontSize: "1.1em", textAlign: "left" }}>
                Table 2 lists details of the temporal remote sensing data (1973
                to 2022), ancillary data, and field data. The remote sensing
                data utilized for land cover dynamics assessment are Landsat
                MSS, Landsat TM, Landsat OLI, and Google Earth
                (http://earth.google.com). Ancillary data included cadastral
                revenue maps (1:6000), the Survey of India (SOI:
                https://surveyofindia.gov.in/) topographic maps (1:50,000 and
                1:250,000 scales), forest categories of 2019, and Forest Survey
                map of India (FSI) for mining area of 1970 from the Forest
                Survey map of India (FSI: https://fsi.nic.in/) [110], land use
                maps (2005-06, 2011-12, 2015-16) from National Remote Sensing
                Center (NRSC: https://nrsc.gov.in), land use (2021) from
                Environmental Systems Research Institute (ESRI:
                https://www.esri.com/), land use (1985, 1995, 2005) from Indian
                Biodiversity Information System (IBIS:
                https://www.indianbiodiversity.org/), Dynamic World Land use
                (2022) (https://dynamicworld.app/) [121], and a vegetation map
                of South India at a scale of 1:250,000 from the French Institute
                (1984) (https://www.ifpindia.org/) [122]. Reserve Forest Area
                (RFA) boundaries representing different forest types were
                collected from the forest department, Goa [123]. Forest
                plantation details were compiled from the North Goa Forest
                Working Plan (2013-14) to (2022-23), the South Goa Forest
                Working Plan (2011-12) to (2020-21) of the Forest Department of
                Goa [123].
              </p>
              <table align="center" width="602">
                <tbody>
                  <tr>
                    <td style={styles.cell} width="170">
                      <p style={{ fontSize: "1.1em" }}>
                        <strong>Data</strong>
                      </p>
                    </td>
                    <td style={styles.cell} width="66">
                      <p style={{ fontSize: "1.1em" }}>
                        <strong>Year </strong>
                      </p>
                    </td>
                    <td style={styles.cell} width="189">
                      <p style={{ fontSize: "1.1em" }}>
                        <strong>Source </strong>
                      </p>
                    </td>
                    <td style={styles.cell} width="47">
                      <p style={{ fontSize: "1.1em" }}>
                        <strong>Data type </strong>
                      </p>
                    </td>
                    <td style={styles.cell} width="66">
                      <p style={{ fontSize: "1.1em" }}>
                        <strong>Temporal resolution </strong>
                      </p>
                    </td>
                    <td style={styles.cell} width="63">
                      <p style={{ fontSize: "1.1em" }}>
                        <strong>Spatial resolution</strong>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td style={styles.cell} colspan="6" width="602">
                      <p style={{ fontSize: "1.1em" }}>
                        <strong>Remote sensing data</strong>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td style={styles.cell} width="170">
                      <p style={{ fontSize: "1.1em" }}>
                        Landsat Multispectral Sensor (MSS)
                      </p>
                    </td>
                    <td style={styles.cell} width="66">
                      <p style={{ fontSize: "1.1em" }}>1973, 1977</p>
                    </td>
                    <td style={styles.cell} width="189">
                      <p style={{ textAlign: "left", fontSize: "1.1em" }}>
                        U.S. Geological
                        Survey&nbsp;https://earthexplorer.usgs.gov/
                      </p>
                    </td>
                    <td style={styles.cell} width="47">
                      <p style={{ fontSize: "1.1em" }}>Raster</p>
                    </td>
                    <td style={styles.cell} width="66">
                      <p style={{ fontSize: "1.1em" }}>16 days</p>
                    </td>
                    <td style={styles.cell} width="63">
                      <p style={{ fontSize: "1.1em" }}>30 m</p>
                    </td>
                  </tr>
                  <tr>
                    <td style={styles.cell} width="170">
                      <p style={{ fontSize: "1.1em" }}>
                        Landsat Thematic Mapper (TM)
                      </p>
                    </td>
                    <td style={styles.cell} width="66">
                      <p style={{ fontSize: "1.1em" }}>
                        1990, 1993, 1998, 2001
                      </p>
                    </td>
                    <td style={styles.cell} width="189">
                      <p style={{ textAlign: "left", fontSize: "1.1em" }}>
                        U.S. Geological
                        Survey&nbsp;https://earthexplorer.usgs.gov/
                      </p>
                    </td>
                    <td style={styles.cell} width="47">
                      <p style={{ fontSize: "1.1em" }}>Raster</p>
                    </td>
                    <td style={styles.cell} width="66">
                      <p style={{ fontSize: "1.1em" }}>16 days</p>
                    </td>
                    <td style={styles.cell} width="63">
                      <p style={{ fontSize: "1.1em" }}>31 m</p>
                    </td>
                  </tr>
                  <tr>
                    <td style={styles.cell} width="170">
                      <p style={{ fontSize: "1.1em" }}>
                        Landsat Operational Land Imagery (OLI)
                      </p>
                    </td>
                    <td style={styles.cell} width="66">
                      <p style={{ fontSize: "1.1em" }}>2014, 2022</p>
                    </td>
                    <td style={styles.cell} width="189">
                      <p style={{ textAlign: "left", fontSize: "1.1em" }}>
                        U.S. Geological
                        Survey&nbsp;https://earthexplorer.usgs.gov/
                      </p>
                    </td>
                    <td style={styles.cell} width="47">
                      <p style={{ fontSize: "1.1em" }}>Raster</p>
                    </td>
                    <td style={styles.cell} width="66">
                      <p style={{ fontSize: "1.1em" }}>16 days</p>
                    </td>
                    <td style={styles.cell} width="63">
                      <p style={{ fontSize: "1.1em" }}>32 m</p>
                    </td>
                  </tr>
                  <tr>
                    <td style={styles.cell} width="170">
                      <p style={{ fontSize: "1.1em" }}>
                        Cartosat Digital Elevation Model (Carto-DEM)
                      </p>
                    </td>
                    <td style={styles.cell} width="66">
                      <p style={{ fontSize: "1.1em" }}>2015</p>
                    </td>
                    <td style={styles.cell} width="189">
                      <p style={{ textAlign: "left", fontSize: "1.1em" }}>
                        U.S. Geological
                        Survey&nbsp;https://earthexplorer.usgs.gov/
                      </p>
                    </td>
                    <td style={styles.cell} width="47">
                      <p style={{ fontSize: "1.1em" }}>Raster</p>
                    </td>
                    <td style={styles.cell} width="66">
                      <p style={{ fontSize: "1.1em" }}>-</p>
                    </td>
                    <td style={styles.cell} width="63">
                      <p style={{ fontSize: "1.1em" }}>1 m</p>
                    </td>
                  </tr>
                  <tr>
                    <td style={styles.cell} width="170">
                      <p style={{ fontSize: "1.1em" }}>
                        Shuttle Radar Topography Mission Digital Elevation Model
                        (SRTM DEM)
                      </p>
                    </td>
                    <td style={styles.cell} width="66">
                      <p style={{ fontSize: "1.1em" }}>2014</p>
                    </td>
                    <td style={styles.cell} width="189">
                      <p style={{ textAlign: "left", fontSize: "1.1em" }}>
                        U.S. Geological
                        Survey&nbsp;https://earthexplorer.usgs.gov/
                      </p>
                    </td>
                    <td style={styles.cell} width="47">
                      <p style={{ fontSize: "1.1em" }}>Raster</p>
                    </td>
                    <td style={styles.cell} width="66">
                      <p style={{ fontSize: "1.1em" }}>-</p>
                    </td>
                    <td style={styles.cell} width="63">
                      <p style={{ fontSize: "1.1em" }}>30 m</p>
                    </td>
                  </tr>
                  <tr>
                    <td style={styles.cell} colspan="6" width="602">
                      <p style={{ fontSize: "1.1em" }}>
                        <strong>Collateral Data</strong>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td style={styles.cell} width="170">
                      <p style={{ fontSize: "1.1em" }}>
                        Survey of India Toposheet
                      </p>
                    </td>
                    <td style={styles.cell} width="66">
                      <p style={{ fontSize: "1.1em" }}>2005-06</p>
                    </td>
                    <td style={styles.cell} width="189">
                      <p style={{ fontSize: "1.1em" }}>surveyofindia.gov.in</p>
                    </td>
                    <td style={styles.cell} width="47">
                      <p style={{ fontSize: "1.1em" }}>Raster</p>
                    </td>
                    <td style={styles.cell} width="66">
                      <p style={{ fontSize: "1.1em" }}>-</p>
                    </td>
                    <td style={styles.cell} width="63">
                      <p style={{ fontSize: "1.1em" }}>1:50000</p>
                    </td>
                  </tr>
                  <tr>
                    <td style={styles.cell} width="170">
                      <p style={{ fontSize: "1.1em" }}>
                        Survey of India Toposheet
                      </p>
                    </td>
                    <td style={styles.cell} width="66">
                      <p style={{ fontSize: "1.1em" }}>1964-66</p>
                    </td>
                    <td style={styles.cell} width="189">
                      <p style={{ textAlign: "left" }}>
                        <a href="https://surveyofindia.gov.in/">
                          surveyofindia.gov.in
                        </a>
                      </p>
                    </td>
                    <td style={styles.cell} width="47">
                      <p style={{ fontSize: "1.1em" }}>Raster</p>
                    </td>
                    <td style={styles.cell} width="66">
                      <p style={{ fontSize: "1.1em" }}>-</p>
                    </td>
                    <td style={styles.cell} width="63">
                      <p style={{ fontSize: "1.1em" }}>1:250000</p>
                    </td>
                  </tr>
                  <tr>
                    <td style={styles.cell} width="170">
                      <p style={{ fontSize: "1.1em" }}>
                        French Institute Vegetation Map of South India
                      </p>
                    </td>
                    <td style={styles.cell} width="66">
                      <p style={{ fontSize: "1.1em" }}>1984</p>
                    </td>
                    <td style={styles.cell} width="189">
                      <p style={{ fontSize: "1.1em" }}>[122]</p>
                    </td>
                    <td style={styles.cell} width="47">
                      <p style={{ fontSize: "1.1em" }}>Raster</p>
                    </td>
                    <td style={styles.cell} width="66">
                      <p style={{ fontSize: "1.1em" }}>-</p>
                    </td>
                    <td style={styles.cell} width="63">
                      <p style={{ fontSize: "1.1em" }}>1:250000</p>
                    </td>
                  </tr>
                  <tr>
                    <td style={styles.cell} width="170">
                      <p style={{ fontSize: "1.1em" }}>
                        Forest Survey of India (FSI) Forest category
                      </p>
                    </td>
                    <td style={styles.cell} width="66">
                      <p style={{ fontSize: "1.1em" }}>2019</p>
                    </td>
                    <td style={styles.cell} width="189">
                      <p style={{ fontSize: "1.1em" }}>[123]</p>
                    </td>
                    <td style={styles.cell} width="47">
                      <p style={{ fontSize: "1.1em" }}>Raster</p>
                    </td>
                    <td style={styles.cell} width="66">
                      <p style={{ fontSize: "1.1em" }}>-</p>
                    </td>
                    <td style={styles.cell} width="63">
                      <p style={{ fontSize: "1.1em" }}>23.5 m</p>
                    </td>
                  </tr>
                  <tr>
                    <td style={styles.cell} width="170">
                      <p style={{ fontSize: "1.1em" }}>
                        Forest Survey of India (FSI) mining area
                      </p>
                    </td>
                    <td style={styles.cell} width="66">
                      <p style={{ fontSize: "1.1em" }}>1970</p>
                    </td>
                    <td style={styles.cell} width="189">
                      <p style={{ fontSize: "1.1em" }}>[123]</p>
                    </td>
                    <td style={styles.cell} width="47">
                      <p style={{ fontSize: "1.1em" }}>Raster</p>
                    </td>
                    <td style={styles.cell} width="66">
                      <p style={{ fontSize: "1.1em" }}>-</p>
                    </td>
                    <td style={styles.cell} width="63">
                      &nbsp;
                    </td>
                  </tr>
                  <tr>
                    <td style={styles.cell} width="170">
                      <p style={{ fontSize: "1.1em" }}>Google Satellite</p>
                    </td>
                    <td style={styles.cell} width="66">
                      <p style={{ fontSize: "1.1em" }}>1985-2023</p>
                    </td>
                    <td style={styles.cell} width="189">
                      <p style={{ fontSize: "1.1em" }}>
                        Google Earth https://earth.google.com/
                      </p>
                    </td>
                    <td style={styles.cell} width="47">
                      <p style={{ fontSize: "1.1em" }}>Raster</p>
                    </td>
                    <td style={styles.cell} width="66">
                      <p style={{ fontSize: "1.1em" }}>-</p>
                    </td>
                    <td style={styles.cell} width="63">
                      <p style={{ fontSize: "1.1em" }}>0.1-5 m</p>
                    </td>
                  </tr>
                  <tr>
                    <td style={styles.cell} width="170">
                      <p style={{ fontSize: "1.1em" }}>
                        National Remote Sensing Centre (NRSC) Land Use
                      </p>
                    </td>
                    <td style={styles.cell} width="66">
                      <p style={{ fontSize: "1.1em" }}>
                        2005-06, 2011-12, 2015-16
                      </p>
                    </td>
                    <td style={styles.cell} width="189">
                      <p style={{ fontSize: "1.1em" }}>
                        <a href="https://bhuvan.nrsc.gov.in/home/index.php">
                          Bhuvan https://bhuvan.nrsc.gov.in/home/index.php&nbsp;
                        </a>
                      </p>
                    </td>
                    <td style={styles.cell} width="47">
                      <p style={{ fontSize: "1.1em" }}>Raster</p>
                    </td>
                    <td style={styles.cell} width="66">
                      <p style={{ fontSize: "1.1em" }}>-</p>
                    </td>
                    <td style={styles.cell} width="63">
                      <p style={{ fontSize: "1.1em" }}>1:50,000</p>
                    </td>
                  </tr>
                  <tr>
                    <td style={styles.cell} width="170">
                      <p style={{ fontSize: "1.1em" }}>
                        Environmental Systems Research Institute (ESRI) Land Use
                      </p>
                    </td>
                    <td style={styles.cell} width="66">
                      <p style={{ fontSize: "1.1em" }}>2021</p>
                    </td>
                    <td style={styles.cell} width="189">
                      <p style={{ fontSize: "1.1em" }}>
                        Esri Land Cover
                        https://livingatlas.arcgis.com/landcover/
                      </p>
                    </td>
                    <td style={styles.cell} width="47">
                      <p style={{ fontSize: "1.1em" }}>Raster</p>
                    </td>
                    <td style={styles.cell} width="66">
                      <p style={{ fontSize: "1.1em" }}>-</p>
                    </td>
                    <td style={styles.cell} width="63">
                      <p style={{ fontSize: "1.1em" }}>10 m</p>
                    </td>
                  </tr>
                  <tr>
                    <td style={styles.cell} width="170">
                      <p style={{ fontSize: "1.1em" }}>
                        Indian Biodiversity Information System Land Use
                      </p>
                    </td>
                    <td style={styles.cell} width="66">
                      <p style={{ fontSize: "1.1em" }}>1985, 1995, 2005</p>
                    </td>
                    <td style={styles.cell} width="189">
                      <p style={{ fontSize: "1.1em" }}>
                        Indian Biodiversity Information System
                        https://www.indianbiodiversity.org/
                      </p>
                    </td>
                    <td style={styles.cell} width="47">
                      <p style={{ fontSize: "1.1em" }}>Raster</p>
                    </td>
                    <td style={styles.cell} width="66">
                      <p style={{ fontSize: "1.1em" }}>-</p>
                    </td>
                    <td style={styles.cell} width="63">
                      <p style={{ fontSize: "1.1em" }}>100 m</p>
                    </td>
                  </tr>
                  <tr>
                    <td style={styles.cell} width="170">
                      <p style={{ fontSize: "1.1em" }}>
                        Dynamic World Land Use
                      </p>
                    </td>
                    <td style={styles.cell} width="66">
                      <p style={{ fontSize: "1.1em" }}>2022</p>
                    </td>
                    <td style={styles.cell} width="189">
                      <p style={{ fontSize: "1.1em" }}>[121]</p>
                    </td>
                    <td style={styles.cell} width="47">
                      <p style={{ fontSize: "1.1em" }}>Raster</p>
                    </td>
                    <td style={styles.cell} width="66">
                      <p style={{ fontSize: "1.1em" }}>-</p>
                    </td>
                    <td style={styles.cell} width="63">
                      <p style={{ fontSize: "1.1em" }}>10 m</p>
                    </td>
                  </tr>
                </tbody>
              </table>
              <p style={{ textAlign: "center" }}>
                <strong>Table 2.</strong> Data used to assess the forest
                structure dynamics.
              </p>
              <p style={{ fontSize: "1.3em" }}>
                <strong>Method</strong>
              </p>
              <p style={{ fontSize: "1.1em" }}>
                Figure 9 outlines the method adopted for assessing ecosystem
                extent and condition, quantification of ecosystem services, and
                geo-visualization of eco-sensitive regions in Goa for prudent
                management of natural resources to ensure the sustenance of
                people's livelihood.
              </p>
              <p style={{ fontSize: "1.1em", textAlign: "center" }}>
                <img
                  width={700}
                  height={600}
                  src="images/final_images/Figure9.png"
                  alt=""
                />
                <br />
                <strong>Figure 9</strong>. Assessment of landscape dynamics and
                prediction of likely land use changes using CA-Markov with AHP
                method.
              </p>
              <ul>
                <li style={{ fontSize: "1.3em" }}>
                  <b>
                    {" "}
                    Assessment of land cover and land use dynamics &ndash;
                    Extent of forest ecosystems
                  </b>
                </li>
              </ul>
              <p style={{ fontSize: "1.1em" }}>
                Assessment of land use dynamics entailed (i) acquisition of
                remote sensing data (1973 to 2022, downloaded from the public
                archive (https://earthexplorer.usgs.gov/), (ii) data
                preprocessing (to rectify geometric and radiometric errors),
                (iii) land use type-wise training data with attribute
                information compilation, (iv) classification of remote sensing
                data using the supervised non-parametric classifier (Random
                Forest algorithm) for deriving land use information, (v)
                validation of classification (through accuracy assessment), (vi)
                compilation ancillary data from the government sources, etc.,
                and digitization of encroachments using forest administrative
                boundaries.
              </p>
              <p style={{ fontSize: "1.1em" }}>
                Ground control points (GCPs) were digitized from the
                geo-referenced topographic maps and scanned paper maps to
                rectify remote sensing data. The vegetation map of South India
                (1984) was used to digitize forest types required to classify
                the remote sensing data. Other ancillary data included land
                cover maps, administration boundary data, and transportation
                data (road network). Attribute data corresponding to the
                training polygons were collected from the field using
                pre-calibrated hand-held GPS (Global Positioning System - Garmin
                GPS units).
              </p>
              <p style={{ fontSize: "1.1em" }}>
                Remote sensing data were geo-referenced, rectified, and cropped
                to correspond to the study region. Remote sensing data from 1973
                and 1977 were resampled to 30 m &times; 30 m to match the
                resolution of post-1990 data. To ensure consistency across the
                time series analysis (1973-2022), Landsat data with a uniform
                spatial resolution of 30 meters was utilized. False Color
                Composite (FCC) using the green, red, and near-infrared (NIR)
                bands of remote sensing data were generated, which aided in
                identifying heterogeneous patches. Training polygons
                corresponding to heterogenous patches were digitized, covering
                15% of the study area and uniformly distributed across the study
                area. The coordinates of these training polygons were
                transferred to pre-calibrated GPS, and attribute data (land use
                types) corresponding to training polygons were collected from
                the field. 70% of the data was used as training data, and the
                remaining 30% was used for the validation or accuracy
                assessment.
              </p>
              <p style={{ fontSize: "1.1em" }}>
                Random forest (R.F.), an ensemble of tree-type machine learning
                classifier [124], was used for the land use classification. R.F.
                has the capability to handle both classification and regression
                tasks, accommodating categorical and continuous variables [124,
                125]. R.F. algorithm creates multiple decision trees (CART),
                based on the training data through bagging or bootstrap
                aggregation [54, 126]. Incorporating the bootstrap component in
                R.F. entails parameterizing each tree using a randomly sampled
                subset of observations from the training data, where sampling is
                done with replacement, which helps in reducing the
                multicollinearity among the trees [127]. R.F. is a combination
                of classifiers where each classifier contributes to the
                classification by voting for the most popular class as input
                (x). Finally, the assignation of the class is based on the
                majority votes of the decision trees.
              </p>
              <p style={{ fontSize: "1.1em" }}>
                R.F. classifier requires optimization of mainly two
                hyperparameters to generate a prediction model. The desired
                number of classification trees (<em>ntrees</em>) and the number
                of prediction variables (<em>mtry</em>) are used at each node to
                grow the tree. &lsquo;m&rsquo; number of random predictive
                variables are employed to classify a new dataset, and each
                dataset example is classified by n trees determined by the user
                [127, 128]. Consequently, for each example final assigned class
                value corresponds to the most frequent value among the total (n)
                generated trees. Additionally, as the number of trees increases,
                the generalization error consistently converges and is not
                sensitive to noise or over-training on R.F. Conversely, reducing
                the number of predictive variables (<em>mtry</em>) makes each
                tree in the model less influential but also diminishes the
                correlation between trees, leading to improved model accuracy.
                Thus, optimizing the parameters <em>ntrees</em> and{" "}
                <em>mtry</em> becomes essential to minimize the generalization
                error [54]. R.F. can handle thousands of input variables and
                estimate the importance of individual variables in the
                classification.
              </p>
              <p style={{ fontSize: "1.1em" }}>
                Initially, the K-means cluster method was utilized to group LU
                categories into clusters based on the spectral signature. The
                clusters were then identified by comparing them with the
                high-spatial-resolution remote sensing data (Google Earth,
                https://earth.google.com) and field data to categorize them into
                specific land use classes. Finally, a hierarchical
                classification scheme was employed to classify land use classes.
              </p>
              <p style={{ fontSize: "1.1em" }}>
                Similarities in spectral characteristics and the
                distinguishability of classes were the criteria considered for
                hierarchical classification. The hierarchical classification
                process consisted of two levels. Level 1 considered
                hierarchically: (i) classification of water and non-water
                classes, (ii) identification of vegetation and non-vegetation
                classes from the non-water class, (iii) vegetation class were
                further classified into forest and non-forest, (iii)
                classification of the forest class into evergreen and non-
                evergreen classes, (iv) further division of the non- evergreen
                class into moist deciduous and dry deciduous/shrubs,&nbsp; (v)
                similarly, non- forest class was further divided into
                horticulture and agriculture. Level 2 followed the hierarchical
                approach of (i) separating the open land and fallow agriculture
                land classes from non-vegetation classes and (ii) mosaicking
                crop and fallow lands.
              </p>
              <p style={{ fontSize: "1.1em" }}>
                <em>Accuracy assessment:</em> Validation of the classification
                of remote sensing data is done through the computation of the
                confusion matrix and Kappa statistics. The confusion matrix
                compares the correlation between the reference data (training
                data) and the classification results, revealing areas of
                agreement and discrepancy. From the information within the error
                matrix, various classification accuracy measures computed are
                omission error, commission error, overall accuracy, producer's
                accuracy, user's accuracy, and the Kappa coefficient, each
                providing unique insights into the quality of the
                classification.
              </p>
              <ul>
                <li style={{ fontSize: "1.3em" }}>
                  <b>
                    Condition of forest ecosystems (assessment through
                    fragmentation metrics)
                  </b>
                </li>
              </ul>
              <p style={{ fontSize: "1.1em" }}>
                The condition of the forest ecosystem is assessed at the pixel
                level through the computation of fragmentation metrics: &nbsp;is
                the ratio of forested pixels to the total number of non-water
                pixels within a defined analysis window. &nbsp;is the proportion
                of adjacent pixel pairs (considering only cardinal directions)
                that include at least one forested pixel, where both pixels are
                classified as forested [129, 95]. These metrics provide valuable
                insights into the spatial distribution, structure, and
                connectivity of forest patches within the landscape [130-133]
                and were categorized as interior, patch, edge, perforated, and
                transitional forest by categorization of pixels based on the
                type of fragmentation as (i) interior forest ( =1), (ii)
                perforated forest (for pixels with &gt; 0.6 and ( &ndash; ) &lt;
                0), (iii) Edge forest ( &gt; 0.6 and ( &ndash; ) &gt; 0), (iv)
                Transition (pixels with &lt;0.6 and &gt;0.4), and (v) Patch
                forest (with pixels &lt; 0.4) [59].
              </p>
              <p style={{ fontSize: "1.1em" }}>
                Based on the condition considering the level of fragmentation,
                forest ecosystems were categorized as (i) Very Dense Forest
                (VDF), corresponding to intact interior zones; (ii) Moderately
                Dense Forest (MDF), consisting of patch and transitional
                forests; and (iii) Degraded Forest (DF), comprising edge and
                perforated forest areas.
              </p>
              <p style={{ fontSize: "1.1em" }}>
                The temporal land use analyses were carried out through the
                random forest (R.F.) classifier in the cloud-based platform
                Google Earth Engine (GEE) [https://earthengine.google.com/].
                Forest fragmentation analysis and spatial land use statistics
                were subsequently derived using the open-source software QGIS
                3.10 [https://www.qgis.org/] and GRASS GIS 7.8.2
                [https://wgbis.ces.iisc.ac.in/grass/].
              </p>
              <ul>
                <li style={{ fontSize: "1.3em" }}>
                  {" "}
                  <b>Prediction of likely land uses using CA-Markov</b>{" "}
                </li>
              </ul>
              <p style={{ fontSize: "1.1em" }}>
                The current study has used the CA-Markov model to assess likely
                land use in the landscape. The Markov chain model considers the
                transition probabilities between different land-use classes over
                time for predicting likely land uses by considering the
                transition probabilities of land-use classes [60]. The
                transition probability matrix [P] and transition area matrix [A]
                are as per equations 1 and 2.
              </p>
              <p style={{ fontSize: "1.1em", textAlign: "center" }}>
                <img
                  style={{ mixBlendMode: "multiply" }}
                  width={200}
                  height={100}
                  src="images/formula/1.png"
                  alt=""
                />
                <br />
                where P<sub>ij</sub> is the probability of i<sup>th</sup> land
                use converting into j<sup>th</sup> class during the transition
                period and n is the number of land use classes.
              </p>
              <p style={{ fontSize: "1.1em", textAlign: "center" }}>
                <img
                  style={{ mixBlendMode: "multiply" }}
                  width={200}
                  height={100}
                  src="images/formula/2.png"
                  alt=""
                />
                <br />
                where A <sub>i,j</sub> is the area of i<sup>th</sup> LU
                transition into j<sup>th</sup> LU class.
              </p>
              <p style={{ fontSize: "1.1em" }}>
                CA-Markov model integrates cellular automata (CA), Markov chain
                (MC), multi-criteria (MCA), and multi-objective land allocation
                (MOLA) to predict or simulate land uses. CA model explicitly
                considers these spatial interactions by defining rules that
                govern the transition of land-use states based on the states of
                neighboring cells (equation 3). This allows for the modeling of
                spatial patterns and propagation of land uses.Top of Form
              </p>
              <p style={{ fontSize: "1.1em", textAlign: "center" }}>
                <img
                  style={{ mixBlendMode: "multiply" }}
                  width={300}
                  height={100}
                  src="images/formula/3.png"
                  alt=""
                />
                <br />
                where S is the set discrete cellular states, N is the Cellular
                field, f is the transformation rule, and t and t + 1 indicate
                the different time instances.
              </p>
              <p style={{ fontSize: "1.1em" }}>
                The model simulates the temporal land-use patterns by updating
                the land-use states based on the defined rules. CA Markov model
                provides insights into the likely future trajectories of land
                uses by considering the effect of natural, societal, and
                economic factors while allowing for the exploration of different
                scenarios [133].
              </p>
              <p style={{ fontSize: "1.1em" }}>
                <em>Analytic Hierarchy Process (AHP):</em> Several modeling
                approaches for multi-criteria analysis in decision-making are
                Artificial Neural Networks (ANN), CA, CA-Markov, and AHP. The
                problem is structured as a hierarchy in AHP, and the process
                involves conducting pair-wise comparisons to determine the
                relative importance of each factor concerning pixel suitability
                for the specific activity and derive weights based on the
                expert&rsquo;s judgment [68, 134]. The weights assigned to the
                variables in the model are determined using the Analytic
                Hierarchy Process (AHP). AHP considers the consistency of the
                decision-making process by assessing the consistency index of
                the individual comparison matrix [135]. In pair-wise comparison,
                matric, two factors are considered at a time. In evaluating
                preferences factors i and j are prioritized as, I = equal
                preference (both &lsquo;i&rsquo; and &lsquo;j&rsquo; factors are
                equally influential in decision making), II = slightly preferred
                (considered i =&gt; j, &lsquo;i&rsquo; is somewhat more
                important than factor 'j&rsquo;), III = significantly prefer (i
                &gt; j, substantial impact of &lsquo;i&rsquo; on
                &lsquo;j&rsquo;), IV = strongly preferred (&lsquo;i&rsquo; have
                strong advantage over &lsquo;j&rsquo;), and V = extremely
                preferred (&lsquo;i&rsquo; is overwhelmingly advantage over
                &lsquo;j&rsquo;). The consistency index depends on the principal
                eigenvector ( ), which is equal to the product between each
                component of the priority vector and the column totals [77,
                114].
              </p>
              <p style={{ fontSize: "1.1em" }}>
                To validate or to measure the level of consistency of the
                pair-wise comparison matrix, the consistency ratio (C.R.) was
                calculated using the given equation 4:
              </p>
              <p style={{ fontSize: "1.1em", textAlign: "center" }}>
                <img
                  style={{ mixBlendMode: "multiply" }}
                  width={200}
                  height={100}
                  src="images/formula/4.png"
                  alt=""
                />
                <br />
                Where, CI is the consistency index (equation 5), and R.I. is the
                Random Index.
              </p>
              <p style={{ fontSize: "1.1em" }}>
                The Random Index suggested by Saaty has been used for the
                computation of C.R., which is represented in Table 3.
              </p>
              <table width="96%">
                <tbody>
                  <tr>
                    <td style={styles.cell} width="9%">
                      <p style={{ fontSize: "1.1em" }}>
                        <strong>n</strong>
                      </p>
                    </td>
                    <td style={styles.cell} width="9%">
                      <p style={{ fontSize: "1.1em" }}>
                        <strong>1</strong>
                      </p>
                    </td>
                    <td style={styles.cell} width="9%">
                      <p style={{ fontSize: "1.1em" }}>
                        <strong>2</strong>
                      </p>
                    </td>
                    <td style={styles.cell} width="9%">
                      <p style={{ fontSize: "1.1em" }}>
                        <strong>3</strong>
                      </p>
                    </td>
                    <td style={styles.cell} width="9%">
                      <p style={{ fontSize: "1.1em" }}>
                        <strong>4</strong>
                      </p>
                    </td>
                    <td style={styles.cell} width="9%">
                      <p style={{ fontSize: "1.1em" }}>
                        <strong>5</strong>
                      </p>
                    </td>
                    <td style={styles.cell} width="9%">
                      <p style={{ fontSize: "1.1em" }}>
                        <strong>6</strong>
                      </p>
                    </td>
                    <td style={styles.cell} width="9%">
                      <p style={{ fontSize: "1.1em" }}>
                        <strong>7</strong>
                      </p>
                    </td>
                    <td style={styles.cell} width="9%">
                      <p style={{ fontSize: "1.1em" }}>
                        <strong>8</strong>
                      </p>
                    </td>
                    <td style={styles.cell} width="7%">
                      <p style={{ fontSize: "1.1em" }}>
                        <strong>9</strong>
                      </p>
                    </td>
                    <td style={styles.cell} width="8%">
                      <p style={{ fontSize: "1.1em" }}>
                        <strong>10</strong>
                      </p>
                    </td>
                  </tr>
                  <tr>
                    <td style={styles.cell} width="9%">
                      <p style={{ fontSize: "1.1em" }}>RI</p>
                    </td>
                    <td style={styles.cell} width="9%">
                      <p style={{ fontSize: "1.1em" }}>0.00</p>
                    </td>
                    <td style={styles.cell} width="9%">
                      <p style={{ fontSize: "1.1em" }}>0.00</p>
                    </td>
                    <td style={styles.cell} width="9%">
                      <p style={{ fontSize: "1.1em" }}>0.58</p>
                    </td>
                    <td style={styles.cell} width="9%">
                      <p style={{ fontSize: "1.1em" }}>0.90</p>
                    </td>
                    <td style={styles.cell} width="9%">
                      <p style={{ fontSize: "1.1em" }}>1.12</p>
                    </td>
                    <td style={styles.cell} width="9%">
                      <p style={{ fontSize: "1.1em" }}>1.24</p>
                    </td>
                    <td style={styles.cell} width="9%">
                      <p style={{ fontSize: "1.1em" }}>1.32</p>
                    </td>
                    <td style={styles.cell} width="9%">
                      <p style={{ fontSize: "1.1em" }}>1.41</p>
                    </td>
                    <td style={styles.cell} width="7%">
                      <p style={{ fontSize: "1.1em" }}>1.45</p>
                    </td>
                    <td style={styles.cell} width="8%">
                      <p style={{ fontSize: "1.1em" }}>1.49</p>
                    </td>
                  </tr>
                </tbody>
              </table>
              <p style={{ fontSize: "1.1em" }}>
                <strong>&nbsp;</strong>
              </p>
              <p style={{ fontSize: "1.1em" }}>
                <strong>Table 3.</strong> Random index (R.I.), according to
                Saaty [77].
              </p>
              <p style={{ fontSize: "1.1em", textAlign: "center" }}>
                <img
                  style={{ mixBlendMode: "multiply" }}
                  width={200}
                  height={100}
                  src="images/formula/5.png"
                  alt=""
                />
                <br />
                where,&nbsp;<em>&lambda;</em>&nbsp;<sub>max</sub>&nbsp;is the
                maximum Eigen value, and it is calculated by Equation (6), P is
                the pair-wise comparison matrix, v represents the matrix
                eigenvector, and <em>n</em>&nbsp;is the number of elements
                compared.
              </p>
              <p style={{ fontSize: "1.1em", textAlign: "center" }}>
                <img
                  style={{ mixBlendMode: "multiply" }}
                  width={250}
                  height={100}
                  src="images/formula/6.png"
                  alt=""
                />
                <br />
                The acceptable consistency ratio (C.R.) of pair-wise comparisons
                should be less than 0.10. If the C.R. is not in the acceptable
                range, then the pair-wise comparison needs to be corrected.
                Consequently, a change in the comparison matrix will change the
                weights assigned to the individual factors.
              </p>
              <p style={{ fontSize: "1.1em" }}>
                The current study employs the IDRISI Selva 17.02 software
                (https://idrisi-selva.software.informer.com/) to model the
                dynamic trajectories of future change and validate the model
                <strong>.</strong>
                <strong> &nbsp;</strong>AHP CA offers several advantages over
                traditional modeling techniques as it incorporates dynamic
                spatial transitions by considering the influence of distances
                for each factor on the respective land use (LU), rather than
                solely focusing on a LU category.
              </p>
              <ul>
                <li style={{ fontSize: "1.3em" }}>
                  <b>Carbon storage services of forest ecosystems</b>
                </li>
              </ul>
              <p style={{ fontSize: "1.1em" }}>
                Forest ecosystems provide a vital service of carbon
                sequestration, which helps in maintaining balance. Carbon stock
                in a forest ecosystem is estimated (Figure 10) using the spatial
                extent of forests and carbon density (forest type-wise) through
                InVEST 3.14.3 carbon storage and sequestration model (available
                at: www.naturalcapitalproject.stanford.edu/software/invest
                /invest-downloads-data developed as part of the natural capital
                accounting endeavor). &nbsp;Carbon density is computed based on
                the field data (sampling across forest types (evergreen, moist
                deciduous, dry deciduous, etc.) through transect-based quadrat
                and measurements of girth and height (species-wise), which were
                used to compute AGB (using species-specific allometric
                equation).
              </p>
              <p style={{ fontSize: "1.1em" }}>&nbsp;</p>
              <p style={{ fontSize: "1.1em" }}>
                InVEST, an open-source tool that simulates the carbon cycle, and
                estimates the total carbon stock by considering four carbon
                pools: above-ground carbon ( ), below-ground biomass ( ), soil
                carbon ( ), and dead organic matter ( ) as given by equation
                7&nbsp; [30, 39, 97].&nbsp;
              </p>
              <p style={{ fontSize: "1.1em", textAlign: "center" }}>
                <img
                  style={{ mixBlendMode: "multiply" }}
                  width={550}
                  height={100}
                  src="images/formula/7.png"
                  alt=""
                />
                <br />
                Where, j = 1,2,.. n and &nbsp;is the area under each land use
                type j.
              </p>
              <p style={{ fontSize: "1.1em" }}>
                Mangroves are critical ecosystems for mitigating climate change,
                acting as efficient carbon sinks through their high rates of
                primary production and organic matter accumulation. Quantifying
                carbon sequestration in mangroves is crucial for understanding
                their ecosystem services and informing conservation and
                management strategies. The current study has assessed the carbon
                sequestration potential of mangroves in Goa using the InVEST
                Carbon model, considering the spatial extent of mangroves and
                carbon density [136, 137, 138]. A comprehensive literature
                review and field investigations were carried out to compile data
                for quantifying aboveground, belowground, and litter carbon
                density (Mg C/ha) through allometric equations [136, 139, 140].
              </p>
              <p style={{ fontSize: "1.1em", textAlign: "center" }}>
                <img
                  style={{ mixBlendMode: "multiply" }}
                  width={870}
                  height={500}
                  src="images/final_images/Figure10.png"
                  alt=""
                />
                <br />
                <strong>Figure 10. </strong>Valuation of carbon services
                (considering the condition of forest ecosystems)
              </p>
              <ul>
                <li style={{ fontSize: "1.3em" }}>
                  {" "}
                  <b> Prioritization of Ecologically Sensitive Regions (ESR)</b>
                </li>
              </ul>
              <p style={{ fontSize: "1.1em" }}>
                ESR or ecologically sensitive regions are unique areas with
                distinct bio-geo-climatic, ecological, and social aspects that
                are easily affected or damaged by human activities, and need to
                be conserved to sustain natural resources and support the
                livelihood of people. Data was compiled from the field and
                through a comprehensive review of published literature,
                published datasets, and official reports. The detailed method is
                as per earlier publications [15,25, 30]. The study area has been
                divided into grids of 5&rsquo;&times;5&rsquo; (9 km &times; 9
                km), which match the grid size of the Survey of India
                topographic maps of 1: 50000 scale and values is assigned to
                each grid based on the relative significance of a variable
                (Supplementary Table S7). The aggregated weight for each grid is
                computed, and grids are grouped into 4 groups based on mean and
                standard deviation of aggregates, which aided in identifying
                various levels of fragility. ESR1 represents ecologically highly
                fragile and requires strict conservation measures; ESR2 is as
                good as ESR1, requiring stringent measures to minimize
                degradation. ESR3 represents a moderate conservation region, and
                ESR4 represents less fragility.
              </p>
              <p style={{ fontSize: "1.1em" }}>
                A web-based Western Ghats Spatial Decision Support System
                (WGSDSS) was conceptualized and implemented to visualize the
                ecologically sensitive regions at disaggregated levels in the
                Western Ghats
                (https://wgbis.ces.iisc.ac.in/sdss/wgsdss/index.php). The WGSDSS
                integrates data (bio-geo-climatic, hydrological, ecological,
                environmental, and social) with the latest spatial technologies
                and provides a powerful platform for geospatial data
                exploration, visualization, and utilization through WMS (web map
                service) and WFS (web feature services) features.
              </p>
              <ul>
                <li style={{ fontSize: "1.3em" }}>
                  {" "}
                  <b>Valuation of ecosystem services</b>{" "}
                </li>
              </ul>
              <p style={{ fontSize: "1.1em" }}>
                Goa State is adjacent and shares its boundary with Uttara
                Kannada district of Karnataka. Valuation of ecosystem services
                (ES) considering the spatial extent and condition of forest
                ecosystems has been done through the benefit transfer method
                considering estimates of economic value for ecosystem services
                for Uttara Kannada district [42, 39], a neighboring district
                with similar ecological, environmental, geo-climatic,
                socio-economic, and cultural factors [97, 115-117, 141, 142].
                The valuation of ecosystem services provides valuable insights
                into the ecological and economic significance of forests for
                opting for policies to ensure sustainable resource management.
              </p>
            </p>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default SAMPage;
